import { AppearanceAppConfig, ConfigState, ThemeConfig } from '../types';

export const formConfigStorageKey = 'cdp-web-demo-form-config';

export const defaultAppearanceAppConfig = {
  appName: 'My App',
  appLogoUrl: '',
  showCoinbaseFooter: true,
} as const satisfies AppearanceAppConfig;

export const defaultThemeConfig = {
  accentColor: 'blue',
  customColor: undefined,
  fontFamily: 'rethinkSans',
  borderRadius: 'xl',
  themeMode: 'light',
} as const satisfies ThemeConfig;

export const initialState: ConfigState = {
  config: {
    ...defaultAppearanceAppConfig,
    authMethods: ['email', 'sms', 'oauth:google', 'oauth:apple', 'oauth:x'],
    ethereum: {
      createOnLogin: 'smart',
    },
    solana: undefined,
  },
  ...defaultThemeConfig,
};

export const defaultAppearanceConfig = {
  ...defaultAppearanceAppConfig,
  ...defaultThemeConfig,
};

export const defaultAppearanceConfigKeys = Object.keys(defaultAppearanceConfig);
